import Invoice, { InvoiceLine, InvoiceListRecord } from '@spike/invoice-model';
import { draft } from '../InvoicesStatuses';

export const toInvoiceListRecordForStatus = (invoice: Invoice, marketplaceName = ''): InvoiceListRecord => ({
    id: invoice.id!,
    uuid: invoice.uuid,
    number: invoice.number!,
    date: invoice.invoiceDate,
    bookingId: invoice.bookingId ?? 0,
    orderId: null,
    marketplace: { id: 0, name: marketplaceName, address: '' },
    customer: {
        email: invoice.customer?.email ?? '',
        name: invoice.customer?.name ?? ''
    },
    grandTotal: Number(invoice.grandTotal),
    balance: Number(invoice.balance),
    paymentsTotal: Number(invoice.payments.total),
    status: invoice.status,
    pdfUrl: invoice.pdfUrl ?? '',
    hasRefunds: Number(invoice.totalRefunds) > 0,
    voidable: invoice.voidable,
    destroyable: invoice.destroyable
});

export const getLineTypeLabel = (line: InvoiceLine): string => {
    if (line.isAddOnService) {
        return 'Add-On';
    }

    if (line.isProduct) {
        return 'Product';
    }

    if (line.appoitnmentId !== null) {
        return 'Service';
    }

    return '';
};

export const getLineName = (line: InvoiceLine): string => line.service?.name || line.description || '';

export const getOriginalLineTotal = (line: InvoiceLine): number | null => {
    const originalTotal = line.quantity * Number(line.subtotal);
    const currentTotal = Number(line.total);

    if (Math.abs(originalTotal - currentTotal) < 0.005) {
        return null;
    }

    return originalTotal;
};

export const getTotalDiscount = (invoice: Invoice): number =>
    Number(invoice.configuredDiscounts.total) + Number(invoice.totalItemsDiscount) + Number(invoice.promocodeDiscounts);

export const isInvoicePaid = (invoice: Invoice): boolean =>
    Number(invoice.grandTotal) > 0 && Number(invoice.balance) === 0;

export const isInvoiceVoided = (invoice: Invoice): boolean => invoice.void;

export const isInvoiceDraft = (invoice: Invoice): boolean => invoice.status === draft;

export const isInvoiceListRecordVoided = (invoice: InvoiceListRecord): boolean => invoice.status === 'void';

export const shouldShowCheckoutOption = (invoice: Invoice): boolean =>
    !isInvoiceDraft(invoice) && !isInvoicePaid(invoice) && !isInvoiceVoided(invoice) && Number(invoice.balance) > 0;
